/* Telemarked Sertifiseringsrapport — per-row scroll trigger + protokoll accordion */
(function(){
  document.querySelectorAll('.sertrapport-section').forEach(function(root){
    var card = root.querySelector('.sertrapport-card');
    var rows = Array.prototype.slice.call(root.querySelectorAll('.sertrapport-row'));
    var total = rows.length;
    if (!card || !total) return;
    var passCountEl = root.querySelector('.sertrapport-pass-count');
    var progressFill = root.querySelector('.sertrapport-progress-fill');
    var bigStamp = root.querySelector('.sertrapport-big-stamp');
    var sig = root.querySelector('.sertrapport-signature-script');

    function updateAggregate(){
      var passed = rows.filter(function(r){ return r.classList.contains('passed'); }).length;
      if (passCountEl) passCountEl.textContent = passed;
      if (progressFill) progressFill.style.width = (passed / total * 100) + '%';
      var done = passed >= total;
      if (bigStamp) bigStamp.classList.toggle('show', done);
      if (sig) sig.classList.toggle('show', done);
    }

    /* Each row triggers PASSERT when its TOP crosses 55% down the viewport.
       Means the row is well-inside the visible area before it changes state. */
    function onScroll(){
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var threshold = vh * 0.55;
      var changed = false;
      rows.forEach(function(row){
        if (row.classList.contains('passed')) return;
        var rect = row.getBoundingClientRect();
        if (rect.top <= threshold) {
          row.classList.add('passed');
          changed = true;
        }
      });
      if (changed) updateAggregate();
    }

    /* Allow manual override via ?testpct=N for design-tool testing */
    var params = new URLSearchParams(window.location.search);
    if (params.has('testpct')) {
      var target = Math.min(total, Math.max(0, parseInt(params.get('testpct'), 10) || 0));
      rows.forEach(function(r, i){ r.classList.toggle('passed', i < target); });
      updateAggregate();
    } else {
      var raf = null;
      function schedule(){ if (raf) return; raf = requestAnimationFrame(function(){ raf = null; onScroll(); }); }
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      schedule();
    }

    /* Protokoll accordion */
    var btn = root.querySelector('.sertrapport-cta');
    var panel = root.querySelector('.sertrapport-protokoll');
    if (btn && panel) {
      var labelEl = btn.querySelector('.sertrapport-cta-text');
      var openLabel = btn.getAttribute('data-open-label') || (labelEl && labelEl.textContent) || 'Se hele testprotokollen';
      var closeLabel = btn.getAttribute('data-close-label') || 'Skjul testprotokollen';

      function setOpen(open){
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var btnTopBefore = btn.getBoundingClientRect().top;
        if (open) {
          panel.hidden = false;
          panel.style.maxHeight = 'none';
          var h = panel.scrollHeight;
          panel.style.maxHeight = '0px';
          panel.style.opacity = '0';
          panel.style.marginTop = '0px';
          requestAnimationFrame(function(){
            panel.style.maxHeight = h + 'px';
            panel.style.opacity = '1';
            panel.style.marginTop = '28px';
          });
          panel.addEventListener('transitionend', function cleanup(){
            panel.style.maxHeight = 'none';
            panel.removeEventListener('transitionend', cleanup);
          }, { once: true });
          if (labelEl) labelEl.textContent = closeLabel;
        } else {
          panel.style.maxHeight = panel.scrollHeight + 'px';
          requestAnimationFrame(function(){
            panel.style.maxHeight = '0px';
            panel.style.opacity = '0';
            panel.style.marginTop = '0px';
          });
          panel.addEventListener('transitionend', function cleanup(){
            panel.hidden = true;
            panel.removeEventListener('transitionend', cleanup);
          }, { once: true });
          if (labelEl) labelEl.textContent = openLabel;
        }
        requestAnimationFrame(function(){
          var drift = btn.getBoundingClientRect().top - btnTopBefore;
          if (Math.abs(drift) > 0.5) window.scrollBy({ top: drift, behavior: 'instant' });
        });
      }

      btn.addEventListener('click', function(){
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        setOpen(!isOpen);
      });
    }
  });
})();
